import { render, staticRenderFns } from "./GeneFamilyBrowse.vue?vue&type=template&id=64cf95a4&scoped=true"
import script from "./GeneFamilyBrowse.vue?vue&type=script&lang=js"
export * from "./GeneFamilyBrowse.vue?vue&type=script&lang=js"
import style0 from "./GeneFamilyBrowse.vue?vue&type=style&index=0&id=64cf95a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf95a4",
  null
  
)

export default component.exports